import { useEffect, useState } from 'react';

export const MOBILE_BREAK = 860;

/**
 * Detects whether the viewport is at/under the mobile breakpoint.
 * same requestAnimationFrame-batched resize handling.
 */
export default function useIsMobile() {
    const [isMobile, setIsMobile] = useState(
        () => typeof window !== 'undefined' && window.innerWidth <= MOBILE_BREAK
    );

    useEffect(() => {
        let raf = 0;
        const onResize = () => {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(() => {
                setIsMobile(window.innerWidth <= MOBILE_BREAK);
            });
        };
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
            cancelAnimationFrame(raf);
        };
    }, []);

    return isMobile;
}
